<template>
  <price-air-numeric-stepper
    v-model="value"
    :show-tact="params.showTact"
    :precision="params.precision"
  />
</template>

<script>
import Vue from 'vue'
import PriceAirNumericStepper from '@/views/cargo/v0/Price/Quotation/components/PriceAirNumericStepper'
export default Vue.extend({
  name: 'CargoAgGridAirNumericInput',
  components: { PriceAirNumericStepper },
  data() {
    return {
      value: null
    }
  },
  created() {
    this.value = this.params.value
  },
  mounted() {
    setTimeout(() => {
      window.addEventListener('click', this.clickOther)
    }, 100)
  },
  destroyed() {
    window.removeEventListener('click', this.clickOther)
  },
  methods: {
    getValue() {
      return this.value
    },
    clickOther(e) {
      if (!this.$el.contains(e.target)) {
        const { api } = this.params
        api.stopEditing()
      }
    }
  }
})
</script>
